var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.07959C5.63965 7.07959 5.76872 7.0542 5.88721 7.00342C6.0057 6.9484 6.11995 6.86377 6.22998 6.74951L10.7051 2.1792C10.8743 2.0057 10.959 1.79834 10.959 1.55713C10.959 1.38786 10.9188 1.23551 10.8384 1.1001C10.758 0.960449 10.6501 0.850423 10.5146 0.77002C10.3792 0.689616 10.229 0.649414 10.064 0.649414C9.81429 0.649414 9.59424 0.744629 9.40381 0.935059L5.25244 5.21973H5.7666L1.59619 0.935059C1.40576 0.744629 1.18783 0.649414 0.942383 0.649414C0.773112 0.649414 0.620768 0.689616 0.485352 0.77002C0.349935 0.850423 0.242025 0.960449 0.161621 1.1001C0.0812174 1.23551 0.0410156 1.38786 0.0410156 1.55713C0.0410156 1.67562 0.0621745 1.78776 0.104492 1.89355C0.151042 1.99512 0.216634 2.09033 0.30127 2.1792L4.77002 6.74951C4.99007 6.96956 5.2334 7.07959 5.5 7.07959Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGray);
export default __webpack_public_path__ + "static/media/arrow-down-gray.07711b0da18f0006680418bee4e04729.svg";
export { ForwardRef as ReactComponent };